
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import GoogleSignIn from "@/components/GoogleSignIn";
import { supabase } from "@/lib/supabase";

const Login = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        navigate("/profile");
      }
    };
    checkAuth();
  }, [navigate]);

  const handleSuccessfulLogin = (userData: any) => {
    // Save user data to localStorage
    localStorage.setItem("user", JSON.stringify(userData));
    
    // Store login timestamp for the merchant profile prompt
    localStorage.setItem('lastAuthEvent', 'SIGNED_IN');
    localStorage.setItem('lastAuthTime', Date.now().toString());
    
    // Create profile in database if it doesn't exist
    const createUserProfile = async (userId: string, userData: any) => {
      try {
        // Check if profile already exists
        const { data: existingProfile, error: fetchError } = await supabase
          .from('profile')
          .select('*')
          .eq('user_id', userId)
          .maybeSingle();
        
        if (fetchError) {
          console.error('Error checking profile:', fetchError);
        }
        
        // If no profile exists, create one
        if (!existingProfile) {
          console.log("Creating profile for user:", userId);
          const { error: insertError } = await supabase
            .from('profile')
            .insert({
              user_id: userId,
              name: userData.name || "User",
              total_points: 0
            });
          
          if (insertError) {
            console.error("Error creating profile:", insertError);
          } else {
            console.log("Profile created successfully");
          }
        }
      } catch (error) {
        console.error("Error in profile creation:", error);
      }
    };
    
    if (userData && userData.id) {
      createUserProfile(userData.id, userData);
    }
    
    // Navigate to profile page
    navigate("/profile");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-4">
      <div className="max-w-md w-full bg-gray-900 p-8 rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold text-center mb-6">Welcome to GrinGauge</h1>
        <p className="text-gray-300 text-center mb-8">
          Record and share emotional moments with your friends and family.
        </p>
        
        <div className="space-y-4">
          <GoogleSignIn onLoginSuccess={handleSuccessfulLogin} />
          
          <div className="text-center">
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => navigate("/")}
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
